import React from "react";

interface ErrorTerminalProps {
  error: string;
}

const ErrorTerminal: React.FC<ErrorTerminalProps> = ({ error }) => {
  return (
    <div className="w-full bg-white rounded-lg overflow-hidden border border-gray-200">
      <div className="flex items-center px-4 py-2 bg-gray-100">
        <div className="flex space-x-2">
          <div className="w-3 h-3 bg-red-500 rounded-full"></div>
          <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
          <div className="w-3 h-3 bg-green-500 rounded-full"></div>
        </div>
        <span className="ml-4 text-sm text-gray-600">
          Terminal de Controle de Erros
        </span>
      </div>
      <div className="p-4 overflow-x-auto">
        <pre className="text-red-600 whitespace-pre-wrap font-mono text-sm">
          {error.split("///").map((line, index) => (
            <React.Fragment key={index}>
              {line}
              {index < error.split("///").length - 1 && <br />}
            </React.Fragment>
          ))}
        </pre>
      </div>
    </div>
  );
};

export default ErrorTerminal;
